// extracted by mini-css-extract-plugin
export default {"container":"drink_container__r0SbS","title":"drink_title__Wj+rt"};